module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subNav"
  }, _vm._l((_vm.dataList), function(data, index) {
    return (_vm.geoView(index)) ? _c('div', {
      key: index,
      class: [_vm.isActive(data.value) ? 'active' : '', _vm.subNavBtn],
      on: {
        "click": function($event) {
          return _vm.tabClick(data.value)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(data.icon))]), _c('span', [_vm._v(_vm._s(data.text))])], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31cc3273","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/SubNav.vue
// module id = 838
// module chunks = 1